





































/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop } from "vue-property-decorator";
import { IArticle } from "../../../Models/ArticleModels/article";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";
import { WordpressPluginDTO } from "../../../Generated/ParticaAPI";

@Component(
	{
		name: "PushWordpress",
		components: { ButtonList }
	})
export default class PushWordpress extends Vue {
	@Prop() private article: IArticle; // your data
	@Prop() private show: boolean;
	@Prop() private showbuttons: boolean;
	@Prop() private buttons: ButtonConfig[];
	@Prop() private plugins: WordpressPluginDTO[];
	private selected: WordpressPluginDTO = new WordpressPluginDTO();


	private getimage() {
		if (this.article !== undefined) {
			return this.article.getFeaturedImage(this.$store.state.config.thumburl, 600);
		}
		return "";
	}
	private buttonClicked(clicked: ParticaEvent) {
		clicked.item = this.selected;
		this.$emit("partica-event", clicked);
	}

	private mounted() {
		if (this.plugins.length > 0) {
			this.selected = this.plugins[0];
		}
	}
}
